module.exports = __webpack_public_path__ + "6c4a0dbc/img/revit-icon.5ff0d581.svg";